import { apiAxios as authAxios } from '../axios.config';

export const getHumanResourceByExternalId = (externalId) => {
  return authAxios.get(`/api/humanResource/${externalId}`)
}